<div class="unauthorized-container">
  <div class="unauthorized-card">
    <div class="icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
      >
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    </div>

    <h1>Session terminée</h1>
    <p class="message">{{ message }}</p>
    <p class="subtitle">Veuillez vous reconnecter pour continuer.</p>

    <div class="actions">
      <button type="button" class="btn-primary" (click)="goToLogin()">Se reconnecter</button>
      <button type="button" class="btn-secondary" (click)="goToHome()">Retour à l'accueil</button>
    </div>
  </div>
</div>
